export default "__VITE_ASSET__dSwIJ6uk__"